export const ENABLE_WORDPRESS = true;
export const ENABLE_ANCHOR_TO_WP_ENTRYPOINTS = true;
